"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EventType;

(function (EventType) {
  EventType["CONNECT"] = "connection";
  EventType["DATA"] = "data";
  EventType["ERROR"] = "error";
  EventType["CLOSE"] = "close";
})(EventType = exports.EventType || (exports.EventType = {}));